import { render, staticRenderFns } from "./GroupPath.vue?vue&type=template&id=b3dd8e40"
import script from "./GroupPath.vue?vue&type=script&lang=js"
export * from "./GroupPath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports